// Small status pill used in table cells. Picks a tone from common status words
// so sections don't each repeat color logic.

const TONES: Record<string, string> = {
  ok: "bg-primary-500/15 text-primary-500",
  warn: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  danger: "bg-red-500/15 text-red-500",
  info: "bg-sky-500/15 text-sky-500",
  muted: "bg-gray-400/15 text-gray-500",
};

const POSITIVE = ["activo", "concedido", "pagado", "confirmada", "confirmado", "usada", "vigente", "online", "completado", "aprobado", "entrada"];
const NEGATIVE = ["inactivo", "denegado", "expirada", "vencido", "cancelada", "cancelado", "offline", "rechazado", "bloqueado"];
const WARNING = ["pendiente", "mantenimiento", "salida", "por vencer", "en proceso", "parcial"];

function toneFor(value: string): string {
  const v = value.trim().toLowerCase();
  if (POSITIVE.includes(v)) return TONES.ok;
  if (NEGATIVE.includes(v)) return TONES.danger;
  if (WARNING.includes(v)) return TONES.warn;
  return TONES.info;
}

export function Badge({ value }: { value: unknown }) {
  const text = String(value ?? "");
  if (!text) return <span className="text-gray-400">—</span>;
  return (
    <span className={`inline-block whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium ${toneFor(text)}`}>
      {text}
    </span>
  );
}
